import React from 'react';
import { Col, Row } from 'antd';
import { PauseOutlined } from '@ant-design/icons';
import { TextSmall } from '../../../../components/text';
import { IconContainerDiv, StatusColumnContainer } from '../../../../styles/global-style';
import { StepIcon } from '../../../../resources';
import { requestStatusObg2 } from '../resource/requestStatusObg';

export const InfoClaimStatus = () => {
  const statusArray = Object.entries(requestStatusObg2).sort(([, a], [, b]) => a.order - b.order);

  return (
    <>
      <Col span={24}>
        <Row align={'middle'} style={{ marginTop: '3px', marginBottom: '3px' }}>
          {statusArray.map(([key, { icon, color, label }], index) => (
            <React.Fragment key={key}>
              <Col>
                <StatusColumnContainer>
                  <IconContainerDiv style={{ color }}>{icon}</IconContainerDiv>
                  <TextSmall>{label}</TextSmall>
                </StatusColumnContainer>
              </Col>
              {index < 2 && (
                <Col>
                  <StepIcon />
                </Col>
              )}
              {index >= 2 && index < statusArray.length - 1 && (
                <Col>
                  <PauseOutlined />
                </Col>
              )}
            </React.Fragment>
          ))}
        </Row>
      </Col>
    </>
  );
};
